import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import './BarChartVertical.styles.scss';
import TotalValue from "../TotalValue/TotalValue";

const BarChartVertical = ({ data, wholeData, moreSpace = false }) => {

    const [maxValue, setMaxValue] = useState(0.0001);

    useEffect(() => {
        let max = 0;
        const checkMax = (item) => {
            const { value, total } = item;
            const values = [value + 2, total + 2].filter(value => value < 100);
            max = Math.max(max, ...values);
        };
        if (wholeData) {
            wholeData.forEach(checkMax);
        } else {
            data.forEach(checkMax);
        }
        setMaxValue(max);
    }, [data, wholeData]);

    return (
        <div className="barChartVertical">
            {data.map((bar, inx) => {
                const title = {
                    component: 'div',
                    props: {
                        className: `barChartVertical__name ${moreSpace ? 'barChartVertical__name--big' : ''}`,
                    }
                };

                if (bar.link) {
                    title.props.to = bar.link;
                    title.component = Link;
                }

                return (
                    <div
                        key={inx}
                        className="barChartVertical__item"
                    >
                        <title.component {...title.props}>
                            {bar.name}
                        </title.component>
                        <div
                            className="barChartVertical__chart-wrap"
                        >
                            <div
                                className={`barChartVertical__bar ${bar.value === 100 ? 'selected-bar' : ''}`}
                                style={{
                                    width: `${((Math.min(bar.value + 2, maxValue) / maxValue) * 100).toFixed(0)}%`
                                }}
                            />
                            {/*<div
                                className="barChartVertical__total"
                                style={{ width: `${(((bar.total + 2)/ maxValue) * 100).toFixed(0)}%` }}
                            >
                                <TotalValue className="barChartVertical__total-value">
                                    {bar.total}%
                                </TotalValue>
                            </div>*/}
                        </div>
                        <div className="barChartVertical__value">{bar.value}%</div>
                    </div>
                )
            })}
        </div>
    )
};

export default BarChartVertical;